import React, { Fragment } from 'react';
import { createPortal } from 'react-dom';
import { defineMessages, FormattedMessage } from 'react-intl';
import Button from '../button';

const messages = defineMessages({
  confirm: {
    id: 'job.actions.confirm',
    defaultMessage: 'Confirm',
  },
  cancel: {
    id: 'job.actions.cancel',
    defaultMessage: 'Cancel',
  },
});

// TODO: can we extend confiramtion dialog from withDialog HOC?
const withConfirmationDialog = (DialogComponent, propName = 'withDialog') => WrappedComponent =>
  class ConfirmationDialog extends React.PureComponent {
    constructor(props) {
      super(props);

      this.state = {
        open: false,
      };

      this.handleOpen = this.handleOpen.bind(this);
      this.handleClose = this.handleClose.bind(this);
      this.renderButtons = this.renderButtons.bind(this);
      this.controller = this.controller.bind(this);
      this.onConfirm = this.onConfirm.bind(this);
      this.onCancel = this.onCancel.bind(this);
    }

    onConfirm(e) {
      this.handleClose(e);
      this.resolve();
    }
    onCancel(e) {
      this.handleClose(e);
      this.reject();
    }

    handleOpen() {
      this.elem = document.createElement('div');
      document.body.appendChild(this.elem);
      this.setState({ open: true });
    }

    handleClose(e) {
      e.stopPropagation();

      this.setState({ open: false }, () => {
        document.body.removeChild(this.elem);
        delete this.elem;
        delete this.resolve;
        delete this.reject;
      });
    }

    controller({ resolve = () => {}, reject = () => {}, ...props }) {
      this.resolve = resolve;
      this.reject = reject;
      this.customProps = props;
      this.handleOpen();
    }

    renderButtons() {
      return (
        <Fragment>
          <Button
            onClick={this.onCancel}
            className="mdc-dialog__footer__button"
          >
            <FormattedMessage {...messages.cancel} />
          </Button>
          <Button
            onClick={this.onConfirm}
            raised
            className="mdc-dialog__footer__button"
          >
            <FormattedMessage {...messages.confirm} />
          </Button>
        </Fragment>
      );
    }

    render() {
      const { open } = this.state;

      return (
        <Fragment>
          <WrappedComponent
            {...{ [propName]: this.controller }}
            {...this.props}
          />
          {open && createPortal(
            <DialogComponent
              {...this.props}
              {...this.customProps}
              buttons={this.renderButtons()}
              onClose={this.handleClose}
              open
              onClick={(e) => { e.stopPropagation(); }}
            />,
            this.elem,
          )}
        </Fragment>
      );
    }
  };

export default withConfirmationDialog;
